import { render, staticRenderFns } from "./Sokoban.vue?vue&type=template&id=5e09dc6c&"
import script from "./Sokoban.vue?vue&type=script&lang=js&"
export * from "./Sokoban.vue?vue&type=script&lang=js&"
import style0 from "./Sokoban.vue?vue&type=style&index=0&id=5e09dc6c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports